import React from "react";
import Routes from "routers/Routes";
import { BrowserRouter } from "react-router-dom";
import { UiProvider } from "contexts/userInterface/UserInterfaceContext";
import { ApiProvider } from "contexts/api/ApiContext";
import "styles/globals.scss";
import "styles/vars.scss";
import { QueryClientProvider } from "react-query";
import { queryClient } from "services/api/Api";
import "./i18n";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

if (!process.env.REACT_APP_DEV) {
  window.console.log = (text: string) => { };
}
function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? ""}>
      <QueryClientProvider client={queryClient}>
        <UiProvider>
          {/* @ts-ignore */}
          <BrowserRouter>
            <ApiProvider>
              <Routes></Routes>
            </ApiProvider>
          </BrowserRouter>
        </UiProvider>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
